__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "unity_shared_admin_management";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.14.0", () => (Promise.all([__webpack_require__.e(956), __webpack_require__.e(532), __webpack_require__.e(297)]).then(() => (() => (__webpack_require__(53532))))));
			register("@azure/msal-browser", "4.30.0", () => (__webpack_require__.e(370).then(() => (() => (__webpack_require__(75370))))));
			register("@azure/msal-react", "3.0.29", () => (Promise.all([__webpack_require__.e(860), __webpack_require__.e(297), __webpack_require__.e(569)]).then(() => (() => (__webpack_require__(91860))))));
			register("@reduxjs/toolkit", "1.9.7", () => (__webpack_require__.e(466).then(() => (() => (__webpack_require__(72466))))));
			register("@unity/auth-lib", "3.0.2", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(297), __webpack_require__.e(569), __webpack_require__.e(69)]).then(() => (() => (__webpack_require__(15950))))));
			register("@unity/react-elements-lib", "11.1.33", () => (Promise.all([__webpack_require__.e(891), __webpack_require__.e(297), __webpack_require__.e(857)]).then(() => (() => (__webpack_require__(63891))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(143), __webpack_require__.e(297)]).then(() => (() => (__webpack_require__(8143))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(261), __webpack_require__.e(297), __webpack_require__.e(857), __webpack_require__.e(647)]).then(() => (() => (__webpack_require__(54261))))));
			register("react-router-dom", "6.30.1", () => (Promise.all([__webpack_require__.e(869), __webpack_require__.e(297), __webpack_require__.e(857)]).then(() => (() => (__webpack_require__(74869))))));
			register("react", "18.3.1", () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};